import type { MouseEvent, PointerEvent } from 'react';

// Гасит событие, чтобы оно не дошло до карточки записи: иначе клик
// открыл бы запись, а движение указателя начало бы перенос. Нужен и для
// содержимого тултипа: он рендерится в портале, но React-события всё
// равно всплывают по дереву компонентов до карточки.
export const stopCardInteraction = (
  event: PointerEvent<HTMLElement> | MouseEvent<HTMLElement>
): void => {
  event.preventDefault();
  event.stopPropagation();
};
